/**
 * Safe wrapper around window.location to facilitate testing.
 * This function allows mocking location properties in Jest without violating
 * JSDOM's read-only constraints on the global window object.
 *
 * @returns {Location} The window.location object or a safe fallback for SSR.
 */
export const getLocation = (): Location => {
  if (typeof window === 'undefined') {
    return {
      pathname: '',
      hostname: '',
      href: '',
      origin: ''
    } as Location;
  }
  return window.location;
};
